import { render, staticRenderFns } from "./diet.vue?vue&type=template&id=c8b69864&scoped=true&"
import script from "./diet.vue?vue&type=script&lang=ts&"
export * from "./diet.vue?vue&type=script&lang=ts&"
import style0 from "./diet.vue?vue&type=style&index=0&id=c8b69864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b69864",
  null
  
)

export default component.exports